import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

import { GlgLoadingSpinner } from 'SharedComponents';
import EventsListContainer from '../containers/events_list_container';
import PortalsListContainer from '../containers/portals_list_container';

const DirectoriesContentComponent = ({ dataIsLoading, showPortals, shouldLoadData, fetchData, fetchMoreData, tourId, noMoreData, filteredDataIsLoading }) => {
  const wrapperRef = useRef(null);
  const sentinelRef = useRef(null); // Reference for dynamically created sentinel
  const isMobile = window.innerWidth <= 579;
  const spinnerHeight = isMobile ? 30 : 50;
  const spinnerWidth = isMobile ? 30 : 50;

  useEffect(() => {
    if (shouldLoadData) {
      fetchData(tourId);
    }

    fetchMoreData(tourId);
  }, [shouldLoadData, fetchData, tourId]);

  useEffect(() => {
    if (!wrapperRef.current) return;

    // Create a sentinel dynamically
    const sentinel = document.createElement('div');

    sentinel.style.height = `${wrapperRef.current.scrollHeight * 0.6}px`;
    sentinel.style.top = `${wrapperRef.current.scrollHeight * 0.4}px`;
    sentinel.style.width = '100%';
    sentinel.style.position = 'absolute';
    sentinel.style.left = '0';
    sentinel.style.zIndex = '-1';

    wrapperRef.current.appendChild(sentinel);
    sentinelRef.current = sentinel;

    const observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        if (entry.isIntersecting && !dataIsLoading && !noMoreData) {
          fetchMoreData(tourId);
        }
      },
      {
        root: null,
        rootMargin: '0px',
        threshold: 0.0001,
      }
    );

    observer.observe(sentinel);

    return () => {
      observer.disconnect();
      if (sentinel.parentNode) {
        sentinel.parentNode.removeChild(sentinel);
      }
    };
  }, [fetchMoreData, tourId, dataIsLoading]);

  useEffect(() => {
    if (!wrapperRef.current || !sentinelRef.current) return;
  
    const contentHeight = wrapperRef.current.scrollHeight;
    sentinelRef.current.style.top = `${contentHeight * 0.4}px`;
    sentinelRef.current.style.height = `${contentHeight * 0.6}px`;
  }, [dataIsLoading]);

  return (
    <div ref={wrapperRef} style={{ position: 'relative' }}>
      <GlgLoadingSpinner height={spinnerWidth} width={spinnerHeight} className={`${!isMobile && 'add-margin-bottom-20'} filter-loading-spinner`} show={filteredDataIsLoading} color="#5092fc" />
      <EventsListContainer />
      <GlgLoadingSpinner className="add-margin-top-20" show={dataIsLoading} color="#5092fc" />
      {showPortals && <PortalsListContainer />}
    </div>
  );
};

DirectoriesContentComponent.propTypes = {
  dataIsLoading: PropTypes.bool.isRequired,
  filteredDataIsLoading: PropTypes.bool,
  showPortals: PropTypes.bool,
  shouldLoadData: PropTypes.bool,
  fetchData: PropTypes.func,
  fetchMoreData: PropTypes.func,
  tourId: PropTypes.string,
  noMoreData: PropTypes.bool,
};

export default DirectoriesContentComponent;
